module.exports = __webpack_public_path__ + "img/En_cofig_1.f9c1ab3e.jpg";